import { GET_CONTRACTS, GET_CONTRACT, SYSTEM_TOAST_SUCCESS_MESSAGE } from './types';

import { serverEndPoint } from './Utils';
import axios from 'axios';

export const getContracts = () => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/contract/getContracts`);
      if (status) {
        let contracts = data.map((c)=>{
          let dataStart = c.startDate.substring(0,10).split('-').reverse().join('-')
          c.startDate = dataStart
          return c
        })
        dispatch({
          type: GET_CONTRACTS,
          payload: contracts,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getContractById = (_id) => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/contract/getContractById/${_id}`);
      if (status) {
        let dataStart = data[0].startDate.substring(0,10)
        data[0].startDate = dataStart

        data[0].secondImage = data[0].secondImage.Key ? data[0].secondImage : false
        data[0].thirdImage = data[0].thirdImage.Key ? data[0].thirdImage : false

        dispatch({
          type: GET_CONTRACT,
          payload: data[0],
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const deleteContractById = (_id) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.delete(`${serverEndPoint}/contract/deleteContractById/${_id}`);
      if (status) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Contrato deletado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const createContract = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.post(`${serverEndPoint}/contract/createContract`, params);
      if (status) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Contrato Adicionado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateContract = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.put(`${serverEndPoint}/contract/updateContract`, params);
      if (status) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Contrato Alterado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};
